import createDebug from '../utils/debug';
import schema from './schema';
import { isObject } from '../utils/validators';
import type { Manifest } from '../shared/types';

const debug = createDebug('manifest:validator');

export default function validateAppManifest(
  manifest?: unknown
): manifest is Manifest {
  if (!isObject(manifest)) return false;

  const candidate = manifest as Record<string, unknown>;

  return (Object.keys(schema) as Array<keyof typeof schema>).every((key) => {
    if (!(key in candidate)) {
      return !schema[key].required;
    }

    return schema[key].validators.every((validator) => {
      // Each schema entry's validators are typed against that field's own
      // value type, but this loop walks all entries generically, so TS can't
      // prove `candidate[key]` matches the specific field `validator` expects
      // — `never` is assignable to any parameter type, which is what lets the
      // per-field-precise types in schema.ts coexist with this generic loop.
      const isValid = validator(candidate[key] as never);

      if (!isValid) {
        debug(
          `prop ${key} invalid for ${validator.name || validator.toString()}`
        );
      }

      return isValid;
    });
  });
}
